import { action, flow, makeObservable, observable } from 'mobx';

import type { AxiosInstance } from 'axios';
import type { DirectoryTableMediator } from 'src/components/directory-table/directory-table-mediator';
import type { IDirectoryPageCurrentDirectory } from 'src/pages/directory/directory-page-service';
import type { IDirectoriesStorage } from 'src/services/directories-storage-service/directories-storage-service';
import type { NotificationsService } from 'src/services/notifications-service';

import { PluginName, type IPlugin } from '../../types';

import { RefreshKeyCloakUsersAndGroupsApi } from './api';

export class RefreshKeyCloakUsersAndGroups implements IPlugin {
  private readonly api: RefreshKeyCloakUsersAndGroupsApi;
  private readonly notificationsService: NotificationsService;
  private readonly directoriesStorageService: IDirectoriesStorage;
  readonly directoryPageService: IDirectoryPageCurrentDirectory;

  readonly name = PluginName.RefreshKeyCloakUsersAndGroups;

  @observable tableMediator: DirectoryTableMediator | null = null;
  @observable isLoading: boolean = false;

  constructor(
    agent: AxiosInstance,
    notificationsService: NotificationsService,
    directoryPageService: IDirectoryPageCurrentDirectory,
    directoriesStorageService: IDirectoriesStorage,
  ) {
    this.api = new RefreshKeyCloakUsersAndGroupsApi(agent);
    this.notificationsService = notificationsService;
    this.directoryPageService = directoryPageService;
    this.directoriesStorageService = directoriesStorageService;

    makeObservable(this);
  }

  @action.bound
  setTableMediator(tableMediator: DirectoryTableMediator): void {
    this.tableMediator = tableMediator;
  }

  @flow.bound
  async *refreshKeyCloak() {
    try {
      this.isLoading = true;

      await this.api.refreshKeyCloakUsersAndGroups();
      yield;

      this.directoriesStorageService.loadObjects('GOlibrary_KeycloakGroup', false);
    } catch (error) {
      this.notificationsService.showErrorMessageT('plugins:RefreshKeyCloakUsersAndGroups.errorRefreshing');
    } finally {
      this.isLoading = false;
    }
  }
}
